import { register } from '../../../Javascript/Utils'

const component = el => {
  const setMediaHeight = () => {
    const mediaWidth = el.offsetWidth
    const mediaHeight = mediaWidth / 1.7777
    el.style.height = mediaHeight + 'px'
  }

  // Initial
  setMediaHeight()

  // Resized
  window.addEventListener('resize', setMediaHeight)
}

const elements = document.querySelectorAll('.medacAtomFullwidthvideo-media')
if (elements.length !== 0) {
  elements.forEach(function (element) {
    const overlayElement = element.querySelector('.video-overlay')
    const videoElement = element.querySelector('video')
    overlayElement.addEventListener('click', function () {
      overlayElement.style.display = 'none'
      videoElement.play()
    })
  })
}

register('media', component)
